import { render, staticRenderFns } from "./alt-table-actions-item.vue?vue&type=template&id=cc21b32e&"
import script from "./alt-table-actions-item.vue?vue&type=script&lang=ts&"
export * from "./alt-table-actions-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports